<template>
  <div class="listing" id="listing-root">
    <div class="title">
      REITs上市列表
      <div class="downloadBtns">
        <CButtonsDownload :dButtonsDownloads="downloadButtons" @fnButtondownload="download" />
        <span style="display: none">
          <download-excel id="listing-download" :data="rows" :fields="exportFields" header="REITs上市列表" name="REITs上市列表.xls" />
        </span>
      </div>
    </div>
    <el-table class="table1" :data="rows" :height="height" :header-cell-style="styleBindFun" @cell-click="goToReit">
      <el-table-column prop="事件类型" label="事件" width="90" fixed />
      <el-table-column prop="上市状态" label="状态" width="90" fixed />
      <el-table-column prop="审核状态" label="审核状态" width="90" />
      <el-table-column prop="REITs代码" label="代码" width="105" fixed />
      <el-table-column prop="REITs简称" label="简称" width="160" fixed />
      <el-table-column prop="L0" label="L0" width="105" />
      <el-table-column prop="L1" label="L1" width="110" />
      <el-table-column prop="L2" label="L2" width="120" />
      <el-table-column prop="上市/扩募日期" label="上市/扩募日期" width="125" sortable />
      <el-table-column prop="发行价" label="发行价" width="90"><template slot-scope="s">{{ number(s.row['发行价'], 3) }}</template></el-table-column>
      <el-table-column prop="开盘价" label="开盘价" width="90"><template slot-scope="s">{{ number(s.row['开盘价'], 3) }}</template></el-table-column>
      <el-table-column prop="发行份额(万份)" label="发行份额(万份)" width="130"><template slot-scope="s">{{ number(s.row['发行份额(万份)'], 2) }}</template></el-table-column>
      <el-table-column prop="总份额(万份)" label="总份额(万份)" width="125"><template slot-scope="s">{{ number(s.row['总份额(万份)'], 2) }}</template></el-table-column>
      <el-table-column prop="市值(万元)" label="市值(万元)" width="120"><template slot-scope="s">{{ number(s.row['市值(万元)'], 2) }}</template></el-table-column>
      <el-table-column prop="流通市值(万元)" label="流通市值(万元)" width="135"><template slot-scope="s">{{ number(s.row['流通市值(万元)'], 2) }}</template></el-table-column>
      <el-table-column prop="流通市值占比" label="流通市值占比" width="125"><template slot-scope="s">{{ percent(s.row['流通市值占比']) }}</template></el-table-column>
      <el-table-column prop="资产估值(万元)" label="评估报告资产估值(万元)" width="180"><template slot-scope="s">{{ number(s.row['资产估值(万元)'], 2) }}</template></el-table-column>
      <el-table-column prop="P/NAV(发行价)" label="P/NAV(发行价)" width="130"><template slot-scope="s">{{ number(s.row['P/NAV(发行价)'], 3) }}</template></el-table-column>
      <el-table-column prop="Cap Rate(发行价)" label="Cap Rate(发行价)" width="140"><template slot-scope="s">{{ percent(s.row['Cap Rate(发行价)']) }}</template></el-table-column>
      <el-table-column prop="Cap Rate(评估值)" label="Cap Rate(评估值)" width="145"><template slot-scope="s">{{ percent(s.row['Cap Rate(评估值)']) }}</template></el-table-column>
      <el-table-column prop="EV/EBITDA(发行价)" label="EV/EBITDA(发行价)" width="155"><template slot-scope="s">{{ number(s.row['EV/EBITDA(发行价)'], 2) }}</template></el-table-column>
      <el-table-column prop="分派率(发行价)" label="分派率(发行价)" width="140"><template slot-scope="s">{{ percent(s.row['分派率(发行价)']) }}</template></el-table-column>
      <el-table-column prop="原始权益人" label="原始权益人" min-width="240" show-overflow-tooltip />
      <el-table-column prop="原始权益人占比" label="原始权益人占比" width="140"><template slot-scope="s">{{ percent(s.row['原始权益人占比'], true) }}</template></el-table-column>
    </el-table>
  </div>
</template>

<script>
import CButtonsDownload from '@/components/Basic/CButtons_download';
import { fnReturnTableStyle } from '@/utils/util';

export default {
  components: { CButtonsDownload },
  data() {
    return {
      rows: [],
      height: 600,
      downloadButtons: [{ id: 'download', name: '下载表格' }],
      exportFields: {},
    };
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() { window.removeEventListener('resize', this.resize); },
  methods: {
    async handleClick() {
      const { data } = await this.$https.get('/api/v2_5/get_listing_events');
      if (data.code !== 200) return this.$message.error(data.msg);
      this.rows = data.data || [];
      this.exportFields = this.rows.length ? Object.keys(this.rows[0]).reduce((out, key) => ({ ...out, [key]: key }), {}) : {};
    },
    resize() { this.height = Math.max(360, document.documentElement.clientHeight - 255); },
    number(value, digits) {
      const n = Number(value);
      return value === '' || value === null || value === undefined || !Number.isFinite(n) ? '--' : n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
    },
    percent(value, alreadyPercent = false) {
      const n = Number(value);
      if (value === '' || value === null || value === undefined || !Number.isFinite(n)) return '--';
      return `${(alreadyPercent ? n : n * 100).toFixed(2)}%`;
    },
    styleBindFun() { return fnReturnTableStyle(this.$store.state.theme === 'dark'); },
    goToReit(row) { if (row['REITs代码']) this.$eventBus.$emit('skipPage', [row['REITs简称'], row['REITs代码']]); },
    download() { document.getElementById('listing-download').click(); },
  },
};
</script>

<style scoped>
.listing { padding-bottom: 20px; }
.title { height: 48px; line-height: 48px; font-size: 18px; color: var(--table_color); }
.downloadBtns { float: right; }
</style>
